import {Injectable, EventEmitter} from '@angular/core';
import * as Rx from 'rxjs/Rx';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class EventsService {  
    // Observable navItem source
    private _navItemSource = new Subject<any>();
    // Observable navItem stream
    navItem$ = this._navItemSource.asObservable();
    // service command
    changeNav(Object) {
        this._navItemSource.next(Object);
    }

    // Observable source
	private _mapClicked = new Subject<any>();	
    // Observable stream
    mapClicked$ = this._mapClicked.asObservable();
    // service command
    mapClicked(evt:any){
        this._mapClicked.next(evt);
    }

	private _mapDrag = new Subject<any>();	
    mapDrag$ = this._mapDrag.asObservable();
    mapDrag(evt:any){
        this._mapDrag.next(evt);
    }

    private _mapPointerDown = new Subject<any>();	
    mapPointerDown$ = this._mapPointerDown.asObservable();
    mapPointerDown(evt:any){
        this._mapPointerDown.next(evt);
    }

    private _mapPointerUp = new Subject<any>();	
    mapPointerUp$ = this._mapPointerUp.asObservable();
    mapPointerUp(evt:any){
        this._mapPointerUp.next(evt);
    }

    private _mapPointerMove = new Subject<any>();
    mapPointerMove$ = this._mapPointerMove.asObservable();
    mapPointerMove(evt:any){
        this._mapPointerMove.next(evt);
    }

    private _mapDoubleClick = new Subject<any>();
    mapDoubleClick$ = this._mapDoubleClick.asObservable();
    mapDoubleClick(evt:any){
        this._mapDoubleClick.next(evt);
    }

    private _addressSearchActivate = new Subject<any>();	
    addressSearchActivate$ = this._addressSearchActivate.asObservable();
    addressSearchActivate(show:boolean){
        this._addressSearchActivate.next(show);
    }

    private _dynamicLayerViewCreated = new Subject();
    dynamicLayerViewCreated$ = this._dynamicLayerViewCreated.asObservable();
    dynamicLayerViewCreated(){
        this._dynamicLayerViewCreated.next(null);
    }

    private _searchToolShow = new Subject<any>();	
    searchToolShow$ = this._searchToolShow.asObservable();
    searchToolShow(show:boolean){
        this._searchToolShow.next(show);
    }

    private _moduleSelect = new Subject<any>();
    moduleSelect$ = this._moduleSelect.asObservable();
    moduleSelect(module:any){
        this._moduleSelect.next(module);
    }

    private _mapUpdateShow = new Subject<boolean>();
    mapUpdateShow$ = this._mapUpdateShow.asObservable();
    mapUpdateShow(show:boolean){
        this._mapUpdateShow.next(show);
    }

    private _expandMenuToolbar = new Subject<boolean>();
    expandMenuToolbar$ = this._expandMenuToolbar.asObservable();
    expandMenuToolbar(show:boolean){
        this._expandMenuToolbar.next(show);
    }

    private _savedSearchSelect = new Subject<any>();
    savedSearchSelect$ = this._savedSearchSelect.asObservable();
    savedSearchSelect(savedSearch:any){
        this._savedSearchSelect.next(savedSearch);
    }

    private _startSaveSearch = new Subject();
    startSaveSearch$ = this._startSaveSearch.asObservable();
    startSaveSearch(){
        this._startSaveSearch.next(null);
    }

    private _setSavedGeometry = new Subject<any>();
    setSavedGeometry$ = this._setSavedGeometry.asObservable();
    setSavedGeometry(savedGeometry:any){
        this._setSavedGeometry.next(savedGeometry);
    }

    private _createAppURL = new Subject<string>();
    createAppURL$ = this._createAppURL.asObservable();
    createAppURL(shareMethod){
        this._createAppURL.next(shareMethod);
    }

    private _appURLCreated = new Subject<string>();
    appURLCreated$ = this._appURLCreated.asObservable();
    appURLCreated(url){
        this._appURLCreated.next(url);
    }

    private _ipaSetLocation = new Subject<any>();
    ipaSetLocation$ = this._ipaSetLocation.asObservable();
    ipaSetLocation(coordinates){
        this._ipaSetLocation.next(coordinates);
    }

    private _ipaSyncLocation = new Subject<any>();
    ipaSyncLocation$ = this._ipaSyncLocation.asObservable();
    ipaSyncLocation(view){
        this._ipaSyncLocation.next(view);
    }

    private _showObliqueImage = new Subject<boolean>();
    showObliqueImage$ = this._showObliqueImage.asObservable();
    showObliqueImage(show){
        this._showObliqueImage.next(show);
    }

    private _disableObliqueImage = new Subject();
    disableObliqueImage$ = this._disableObliqueImage.asObservable();
    disableObliqueImage(){
        this._disableObliqueImage.next();
    }

    private _showMapTooltip = new Subject<any>();
    showMapTooltip$ = this._showMapTooltip.asObservable();
    showMapTooltip(parameters){
        this._showMapTooltip.next(parameters);
    }

    private _parcelReportGenerated = new Subject();
    parcelReportGenerated$ = this._parcelReportGenerated.asObservable();
    parcelReportGenrated(){
        this._parcelReportGenerated.next();
    }

    private _identifyLocationChanged = new Subject<any>();
    identifyLocationChanged$ = this._identifyLocationChanged.asObservable();
    identifyLocationChanged(parameters){
        this._identifyLocationChanged.next(parameters);
    }
}


// WEBPACK FOOTER //
// ./app/EventsService.ts